import React from "react";
import numeral from "numeral";
import T from "prop-types";
import { Stat } from "MODULES/shared/components";
import { properCase } from "LIB/formatters/text";

const salesSum = data =>
  data.sellers.reduce((sum, result) => sum + result.total_sales, 0);

const profit = data =>
  data.sellers.reduce((sum, result) => sum + result.total_profit, 0);

const percentProfit = data =>
  salesSum(data) !== 0 ? profit(data) / salesSum(data) : 0;

export function SalesCount({ data, dateLabel }) {
  return (
    <Stat
      label={`# Sales - ${dateLabel}`}
      value={numeral(data.num_sales).format("(0,0)")}
    />
  );
}

SalesCount.propTypes = {
  dateLabel: T.string,
  data: T.arrayOf(T.shape({}))
};

export function SaleLinesCount({ data, dateLabel }) {
  return (
    <Stat
      label={`# SO Lines - ${dateLabel}`}
      value={numeral(data.num_line_items).format("(0,0)")}
    />
  );
}

SaleLinesCount.propTypes = {
  dateLabel: T.string,
  data: T.arrayOf(T.shape({}))
};

export function SalesSum({ data, dateLabel }) {
  return (
    <Stat
      label={`$ Bookings - ${dateLabel}`}
      value={numeral(salesSum(data)).format("($0,0)")}
    />
  );
}

SalesSum.propTypes = {
  dateLabel: T.string,
  data: T.arrayOf(T.shape({}))
};

GrossSalesSum.propTypes = {
  data: T.arrayOf(T.shape({}))
};

export function GrossSalesSum({ data, dateLabel }) {
  return (
    <Stat
      label={`$ Sales - ${properCase(dateLabel)}`}
      value={numeral(data.gross_sales).format("($0,0)")}
    />
  );
}

GrossSalesSum.propTypes = {
  data: T.arrayOf(T.shape({})),
  dateLabel: T.string
};

export function SalesSumProjection({ data, dateLabel }) {
  return (
    <Stat
      label={`$ Sales On Track For - ${dateLabel}`}
      value={numeral(data.sales_projection).format("($0,0)")}
    />
  );
}

export function ProfitSumProjection({ data, dateLabel }) {
  return (
    <Stat
      label={`$ Profit On Track For - ${dateLabel}`}
      value={numeral(data.profit_projection).format("($0,0)")}
    />
  );
}

ProfitSumProjection.propTypes = {
  dateLabel: T.string,
  data: T.arrayOf(T.shape({}))
};

SalesSumProjection.propTypes = {
  dateLabel: T.string,
  data: T.arrayOf(T.shape({}))
};

export function SalesSumProjectionNA({ dateLabel }) {
  return <Stat label={`$ Sales On Track For - ${dateLabel}`} value="N/A" />;
}

SalesSumProjectionNA.propTypes = {
  dateLabel: T.string
};

export function SalesProfit({ data, dateLabel }) {
  return (
    <Stat
      label={`$ Profit - ${dateLabel}`}
      value={numeral(profit(data)).format("($0,0")}
    />
  );
}

SalesProfit.propTypes = {
  dateLabel: T.string,
  data: T.arrayOf(T.shape({}))
};

export function SalesPercentProfit({ data, dateLabel }) {
  return (
    <Stat
      label={`% Profit - ${dateLabel}`}
      value={numeral(percentProfit(data)).format("(0.0%)")}
    />
  );
}

SalesPercentProfit.propTypes = {
  dateLabel: T.string,
  data: T.arrayOf(T.shape({}))
};

export function SalesPercentGoal({ data, dateLabel }) {
  return (
    <Stat
      label={`% of Goal - ${dateLabel}`}
      value={numeral(data.sales_percent_goal).format("(0.0%)")}
    />
  );
}

SalesPercentGoal.propTypes = {
  dateLabel: T.string,
  data: T.arrayOf(T.shape({}))
};



// WEBPACK FOOTER //
// ./app/modules/SalesDashboard/Components/Stats.jsx